import { gql } from 'graphql-tag'

const toiletCheckQuestionFragment = gql`
  fragment ToiletCheckQuestionFragment on ToiletCheckQuestion {
    id
    description
    station {
      id
    }
  }
`

export const toiletCheckQuestionsQuery = gql`
  query ToiletCheckQuestions($stationId: ID) {
    toiletCheckQuestions(stationId: $stationId) {
      ...ToiletCheckQuestionFragment
    }
  }
  ${toiletCheckQuestionFragment}
`

export const createToiletCheckQuestionMutation = gql`
  mutation CreateToiletCheckQuestion($description: String!, $stationId: ID) {
    createToiletCheckQuestion(description: $description, stationId: $stationId) {
      ...ToiletCheckQuestionFragment
    }
  }
  ${toiletCheckQuestionFragment}
`

export const updateToiletCheckQuestionMutation = gql`
  mutation UpdateToiletCheckQuestion($id: ID!, $description: String!) {
    updateToiletCheckQuestion(toiletCheckQuestionId: $id, description: $description) {
      ...ToiletCheckQuestionFragment
    }
  }
  ${toiletCheckQuestionFragment}
`

export const deleteToiletCheckQuestionMutation = gql`
  mutation DeleteToiletCheckQuestion($id: ID!) {
    deleteToiletCheckQuestion(toiletCheckQuestionId: $id)
  }
`
